import useTitleTranslation from "hooks/useTitleTranslation";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const TranslationBreadcrumb = ({ name, defaultTitle }) => {
  const { t } = useTranslation();
  const { getTitle } = useTitleTranslation();

  const title = useMemo(() => {
    if (getTitle(name, defaultTitle)) {
      return getTitle(name, t(defaultTitle));
    }
    return t(name || defaultTitle);
  }, [name, t, getTitle, defaultTitle]);
  return <span>{title}</span>;
};

export default TranslationBreadcrumb;
